import { Modal } from "react-bootstrap";
import { BADGE_LABEL, MENSAJE_ESTADO } from "../constants/mensajesEstado";

const MESES = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];

const formatFecha = (fechaIso) => {
  if (!fechaIso) return "";
  const date = new Date(fechaIso);
  return `${date.getDate()} ${MESES[date.getMonth()]} ${date.getFullYear()}`;
};

const ModalMensajes = ({ autorizacion, onClose, nombreUsuario }) => {
  const estado = autorizacion?.estado ?? "";
  const badgeLabel = BADGE_LABEL[estado] ?? estado;
  const estadoSlug = estado.toLowerCase().replace(/\s+/g, "-");
  const mensajeRaw = MENSAJE_ESTADO[estado] ?? "";
  // MENSAJE_ESTADO puede ser string o array de strings (mensajes multi-párrafo)
  const mensajeParrafos = Array.isArray(mensajeRaw) ? mensajeRaw : mensajeRaw ? [mensajeRaw] : [];

  return (
    <Modal show={Boolean(autorizacion)} onHide={onClose} centered dialogClassName="modal-autorizacion">
      <Modal.Header closeButton style={{ border: "none", alignItems: "flex-start" }}>
        <div className="d-flex align-items-center flex-wrap" style={{ justifyContent: "space-between", width: "100%" }}>
          <Modal.Title style={{ fontSize: "16px", fontWeight: "bold" }}>
            {autorizacion?.especialidad ?? autorizacion?.tipoPedido ?? ""}
          </Modal.Title>
          {badgeLabel && (
            <span style={{ backgroundColor: "#224d7c", color: "#fff", borderRadius: "20px", padding: "8px 16px", fontSize: "16px", display: "flex", alignItems: "center", justifyContent: "center" }}>
              {badgeLabel}
            </span>
          )}
        </div>
      </Modal.Header>

      <Modal.Body style={{ paddingTop: "4px" }}>
        <div style={{ marginBottom: "20px" }}>
          {nombreUsuario && (
            <p style={{ margin: 0, fontWeight: "500", color: "#000", fontSize: "14px" }}>{nombreUsuario}</p>
          )}
          <p style={{ margin: 0, color: "#555", fontSize: "13px" }}>
            {formatFecha(autorizacion?.fecha)}
          </p>
        </div>
        <hr style={{ margin: "0 0 20px 0", borderColor: "#224d7c" }} />
        {mensajeParrafos.map((parrafo, i) => (
          <p
            key={i}
            style={{
              textAlign: "left",
              fontSize: "15px",
              margin: 0,
              marginBottom: i < mensajeParrafos.length - 1 ? "12px" : "20px",
              color: "#000",
            }}
          >
            {parrafo}
          </p>
        ))}
        <p style={{ margin: 0, fontWeight: "bold", color: "#000" }}>
          ¡Gracias!
        </p>
      </Modal.Body>
    </Modal>
  );
};

export default ModalMensajes;
